import type { Dispatch } from "@reduxjs/toolkit";

import type { NodeAction, SlotId } from "../../schemas/index.ts";
import type { NautilusDesignerState } from "../managed/index.ts";

export const nodeIdParamSelector = (_: NautilusDesignerState, { nodeId }: { nodeId: number }) => nodeId;

export const slotIdParamSelector = (_: NautilusDesignerState, { slotId }: { slotId: SlotId }) => slotId;

export const nodeTypeIdParamSelector = (_: NautilusDesignerState, { typeId }: { typeId: string }) => typeId;

export const dispatchParamSelector = (_: NautilusDesignerState, { dispatch }: { dispatch: Dispatch<NodeAction> }) =>
  dispatch;
